// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import FinanceAccountType from "./finance-account-type.js"
import FinanceDimensionValue from "./finance-dimension-value.js"

const modelClassData = {
  "attributes": {
    "account_number": {
      "column": {
        "default": null,
        "name": "account_number",
        "null": true,
        "type": "string"
      },
      "name": "account_number",
      "selected_by_default": null,
      "translated": false
    },
    "book_expense_locked": {
      "column": {
        "default": true,
        "name": "book_expense_locked",
        "null": false,
        "type": "boolean"
      },
      "name": "book_expense_locked",
      "selected_by_default": null,
      "translated": false
    },
    "book_time_locked": {
      "column": {
        "default": true,
        "name": "book_time_locked",
        "null": false,
        "type": "boolean"
      },
      "name": "book_time_locked",
      "selected_by_default": null,
      "translated": false
    },
    "book_travel_locked": {
      "column": {
        "default": true,
        "name": "book_travel_locked",
        "null": false,
        "type": "boolean"
      },
      "name": "book_travel_locked",
      "selected_by_default": null,
      "translated": false
    },
    "direct_posting": {
      "column": {
        "default": false,
        "name": "direct_posting",
        "null": false,
        "type": "boolean"
      },
      "name": "direct_posting",
      "selected_by_default": null,
      "translated": false
    },
    "expense_locked": {
      "column": {
        "default": true,
        "name": "expense_locked",
        "null": false,
        "type": "boolean"
      },
      "name": "expense_locked",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": null,
      "translated": true
    },
    "nemoa_locked": {
      "column": {
        "default": true,
        "name": "nemoa_locked",
        "null": false,
        "type": "boolean"
      },
      "name": "nemoa_locked",
      "selected_by_default": null,
      "translated": false
    },
    "time_locked": {
      "column": {
        "default": true,
        "name": "time_locked",
        "null": false,
        "type": "boolean"
      },
      "name": "time_locked",
      "selected_by_default": null,
      "translated": false
    },
    "travel_locked": {
      "column": {
        "default": true,
        "name": "travel_locked",
        "null": false,
        "type": "boolean"
      },
      "name": "travel_locked",
      "selected_by_default": null,
      "translated": false
    }
  },
  "className": "FinanceAccount",
  "collectionKey": "finance_accounts",
  "collectionName": "finance_accounts",
  "i18nKey": "finance_account",
  "camelizedLower": "financeAccount",
  "name": "FinanceAccount",
  "nameDasherized": "finance-account",
  "pluralName": "finance_accounts",
  "ransackable_associations": [
    {
      "className": "FinanceAccount::Translation",
      "collectionName": null,
      "foreignKey": "finance_account_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "EmployeePrice",
      "collectionName": "employee_prices",
      "foreignKey": "finance_account_id",
      "name": "employee_prices",
      "macro": "has_many",
      "resource_name": "EmployeePrice",
      "through": null
    },
    {
      "className": "FinanceAccountFinanceDimensionValue",
      "collectionName": "finance_account_finance_dimension_values",
      "foreignKey": "finance_account_id",
      "name": "finance_account_finance_dimension_values",
      "macro": "has_many",
      "resource_name": "FinanceAccountFinanceDimensionValue",
      "through": null
    },
    {
      "className": "FinanceAccountType",
      "collectionName": "finance_account_types",
      "foreignKey": "finance_account_type_id",
      "name": "finance_account_type",
      "macro": "belongs_to",
      "resource_name": "FinanceAccountType",
      "through": null
    },
    {
      "className": "FinanceDimensionValue",
      "collectionName": "finance_dimension_values",
      "foreignKey": "finance_dimension_value_id",
      "name": "finance_dimension_values",
      "macro": "has_many",
      "resource_name": "FinanceDimensionValue",
      "through": "finance_account_finance_dimension_values"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Plan",
      "collectionName": "plans",
      "foreignKey": "finance_account_id",
      "name": "plans",
      "macro": "has_many",
      "resource_name": "Plan",
      "through": null
    },
    {
      "className": "Reimbursement",
      "collectionName": "reimbursements",
      "foreignKey": "finance_account_id",
      "name": "reimbursements",
      "macro": "has_many",
      "resource_name": "Reimbursement",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "FinanceAccount::Translation",
      "collectionName": null,
      "foreignKey": "finance_account_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "account_number",
      "column": {
        "default": null,
        "name": "account_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "book_expense_locked",
      "column": {
        "default": true,
        "name": "book_expense_locked",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "book_time_locked",
      "column": {
        "default": true,
        "name": "book_time_locked",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "book_travel_locked",
      "column": {
        "default": true,
        "name": "book_travel_locked",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "deleted_in_inventio_at",
      "column": {
        "default": null,
        "name": "deleted_in_inventio_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "direct_posting",
      "column": {
        "default": false,
        "name": "direct_posting",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "expense_locked",
      "column": {
        "default": true,
        "name": "expense_locked",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "finance_account_type_id",
      "column": {
        "default": null,
        "name": "finance_account_type_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "nemoa_locked",
      "column": {
        "default": true,
        "name": "nemoa_locked",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "old_finance_account_type_id",
      "column": {
        "default": null,
        "name": "old_finance_account_type_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "time_locked",
      "column": {
        "default": true,
        "name": "time_locked",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "travel_locked",
      "column": {
        "default": true,
        "name": "travel_locked",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    },
    {
      "name": "with_finance_dimension_values"
    }
  ],
  "relationships": [
    {
      "className": "FinanceAccountType",
      "collectionName": "finance_account_types",
      "foreignKey": "finance_account_type_id",
      "name": "finance_account_type",
      "macro": "belongs_to",
      "resource_name": "FinanceAccountType",
      "through": null
    },
    {
      "className": "FinanceDimensionValue",
      "collectionName": "finance_dimension_values",
      "foreignKey": "finance_dimension_value_id",
      "name": "finance_dimension_values",
      "macro": "has_many",
      "resource_name": "FinanceDimensionValue",
      "through": "finance_account_finance_dimension_values"
    }
  ],
  "paramKey": "finance_account",
  "primaryKey": "id"
}

/** Frontend model for FinanceAccount. */
export default class FinanceAccount extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  accountNumber() {
    return this.readAttributeUnderscore("account_number")
  }

  /** @returns {boolean} */
  hasAccountNumber() {
    const value = this.accountNumber()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  bookExpenseLocked() {
    return this.readAttributeUnderscore("book_expense_locked")
  }

  /** @returns {boolean} */
  hasBookExpenseLocked() {
    const value = this.bookExpenseLocked()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  bookTimeLocked() {
    return this.readAttributeUnderscore("book_time_locked")
  }

  /** @returns {boolean} */
  hasBookTimeLocked() {
    const value = this.bookTimeLocked()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  bookTravelLocked() {
    return this.readAttributeUnderscore("book_travel_locked")
  }

  /** @returns {boolean} */
  hasBookTravelLocked() {
    const value = this.bookTravelLocked()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  directPosting() {
    return this.readAttributeUnderscore("direct_posting")
  }

  /** @returns {boolean} */
  hasDirectPosting() {
    const value = this.directPosting()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  expenseLocked() {
    return this.readAttributeUnderscore("expense_locked")
  }

  /** @returns {boolean} */
  hasExpenseLocked() {
    const value = this.expenseLocked()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  nemoaLocked() {
    return this.readAttributeUnderscore("nemoa_locked")
  }

  /** @returns {boolean} */
  hasNemoaLocked() {
    const value = this.nemoaLocked()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  timeLocked() {
    return this.readAttributeUnderscore("time_locked")
  }

  /** @returns {boolean} */
  hasTimeLocked() {
    const value = this.timeLocked()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  travelLocked() {
    return this.readAttributeUnderscore("travel_locked")
  }

  /** @returns {boolean} */
  hasTravelLocked() {
    const value = this.travelLocked()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static sync(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "sync",
        collectionName: "finance_accounts",
        type: "collection"
      },
      commandArgs
    ))
  }

  /** @returns {import("./finance-account-type.js").default | null} */
  financeAccountType() {
    return this._readBelongsToReflection({modelClass: FinanceAccountType, reflectionName: "finance_account_type"})
  }

  /** @returns {Promise<import("./finance-account-type.js").default | null>} */
  loadFinanceAccountType() {
    if (!("financeAccountTypeId" in this)) throw new Error("Foreign key method wasn't defined: financeAccountTypeId")

    const id = this.financeAccountTypeId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "finance_account_type",
        model: this,
        modelClass: FinanceAccountType
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./finance-account-type.js").default | null>} */
  ensureFinanceAccountTypeLoaded() {
    return this.ensureAssociationLoaded("finance_account_type")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./finance-dimension-value.js").default>} */
  financeDimensionValues() {
    return new Collection(
      {
        reflectionName: "finance_dimension_values",
        model: this,
        modelClass: FinanceDimensionValue
      },
      {
        params: {
          through: {
            model: "FinanceAccount",
            id: this.primaryKey(),
            reflection: "finance_dimension_values"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./finance-dimension-value.js").default>>} */
  loadFinanceDimensionValues() {
    return this._loadHasManyReflection(
      {
        reflectionName: "finance_dimension_values",
        model: this,
        modelClass: FinanceDimensionValue
      },
      {
        params: {
          through: {
            model: "FinanceAccount",
            id: this.primaryKey(),
            reflection: "finance_dimension_values"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./finance-dimension-value.js").default>>} */
  ensureFinanceDimensionValuesLoaded() {
    return this.ensureAssociationLoaded("finance_dimension_values")
  }
}
